import { render } from "./DatabaseSync.vue?vue&type=template&id=7e0cd0be&scoped=true"
import script from "./DatabaseSync.vue?vue&type=script&lang=js"
export * from "./DatabaseSync.vue?vue&type=script&lang=js"

import "./DatabaseSync.vue?vue&type=style&index=0&id=7e0cd0be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0cd0be"]])

export default __exports__